import { z } from "zod";

export const settingsSchema = z.object({
	name: z.string().min(1, "Template Name is required"),
	description: z.string().optional(),
	url: z
		.string()
		.min(1, "Document URL or file is required")
		.refine(
			(val) =>
				val.startsWith("http://") ||
				val.startsWith("https://") ||
				val.startsWith("data:"),
			"URL must start with https:// or be an uploaded file",
		),
	checklistItemId: z.string().min(1, "Document Type is required"),
});

export type SettingsFormData = z.infer<typeof settingsSchema>;
